import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconJob(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M14 6V4h-4v2h4ZM4 9v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1Zm16-3c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
